import { useContext as o } from "../../external/preact/hooks/dist/hooks.module.js";
import { CoreContext as t } from "./CoreContext.js";
const s = () => o(t);
export {
  s as default
};
